import { FormPartComponent, Select as SelectType } from "./FormParts";
import { FieldLabel } from "./Input";
import { useEffect, useState } from "react";
import { shopVar } from "@/lib/shopStyles";
import * as m from "@/paraglide/messages.js";

export function Select({ formPart, onValueChange, onValidStatusChange, answers, errors }: FormPartComponent<SelectType>) {
    if (answers && typeof answers !== 'string') {
        answers = '';
    }

    let initialValue = '';
    if (answers && typeof answers === 'string' && answers.trim() !== '') {
        initialValue = answers;
    }

    const [value, setValue] = useState<string>(initialValue);

    // Initial validation and notify backend of default value
    useEffect(() => {
        onValidStatusChange(formPart.key, validateSelect(value || ''));
        onValueChange(formPart.key, value);
    }, [formPart.required]);

    const validateSelect = (selectedValue: string) => {
        if (!formPart.required) {
            return true;
        }
        return selectedValue.trim().length > 0;
    };

    const handleSelectChange = (newValue: string) => {
        setValue(newValue);
        onValueChange(formPart.key, newValue);
        onValidStatusChange(formPart.key, validateSelect(newValue));
    };

    // Use the backend placeholder only when it's a genuine prompt. It's
    // sometimes populated with the first answer, which would render the first
    // option twice, so fall back to a neutral localized prompt in that case.
    const placeholderCollidesWithOption = formPart.options.some(
        (option) => option.value === formPart.placeholder || option.key === formPart.placeholder,
    );
    const placeholderLabel =
        formPart.placeholder && !placeholderCollidesWithOption
            ? formPart.placeholder
            : m.form_select_placeholder();

    return (
        <div className="grid grid-cols-1 gap-4 pt-4" data-form-part={formPart.key}>
            <FieldLabel label={formPart.label} required={formPart.required} />
            <select
                value={value}
                onChange={(e) => handleSelectChange(e.target.value)}
                className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
                style={{
                    color: shopVar('--shop-textColor'),
                    backgroundColor: shopVar('--shop-panelBackgroundColor'),
                    // @ts-expect-error --tw-ring-color is not a valid CSS property
                    '--tw-ring-color': shopVar('--shop-borderColor'),
                }}
            >
                <option value="" disabled={formPart.required}>
                    {placeholderLabel}
                </option>
                {formPart.options.map((option) => (
                    <option key={option.key} value={option.key}>
                        {option.value}
                    </option>
                ))}
            </select>
            {formPart.description && (
                <p className="text-sm text-gray-500">{formPart.description}</p>
            )}
            {errors.length > 0 && (
                <p className="mt-2 text-sm text-red-600">{errors[0]}</p>
            )}
        </div>
    );
} 